import { render, staticRenderFns } from "./puApplayUditList.vue?vue&type=template&id=2c910aa3&scoped=true"
import script from "./puApplayUditList.vue?vue&type=script&lang=js"
export * from "./puApplayUditList.vue?vue&type=script&lang=js"
import style0 from "./puApplayUditList.vue?vue&type=style&index=0&id=2c910aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c910aa3",
  null
  
)

export default component.exports